<div class="menu-item-container"
     [attr.data-size]="size"
     [attr.data-type]="type"
     [attr.data-disabled]="isDisabled"
     [attr.data-selected]="isSelected"
     [attr.data-destructive]="isDestructive">

  <button type="button"
          class="menu-item"
          [disabled]="isDisabled"
          [attr.role]="'menuitem'"
          [attr.aria-label]="displayLabel + (displayDescription ? ' - ' + displayDescription : '')"
          [attr.aria-selected]="isSelected"
          [attr.aria-disabled]="isDisabled"
          [attr.tabindex]="isDisabled ? -1 : 0"
          (click)="onItemClick()"
          (mouseenter)="onItemHover()"
          (focus)="onItemFocus()"
          (keydown)="onKeyDown($event)">

    <!-- Projected Avatar (before icon) -->
    <ng-content select="umss-avatar"></ng-content>

    <!-- Icon (Left decoration) -->
    <span *ngIf="displayIconName" class="menu-item-icon">
      <umss-icon [name]="displayIconName" [size]="iconSize"></umss-icon>
    </span>

    <!-- Content -->
    <div class="menu-item-content">
      <!-- Label -->
      <span class="menu-item-label">{{ displayLabel }}</span>
      
      <!-- Description -->
      <span *ngIf="displayDescription" class="menu-item-description">
        {{ displayDescription }}
      </span>
    </div>

    <!-- Shortcut -->
    <span *ngIf="displayShortcut" class="menu-item-shortcut">
      {{ displayShortcut }}
    </span>

    <!-- Projected Decoration (Right decoration) -->
    <ng-content select="umss-decoration"></ng-content>

    <!-- Selected Indicator -->
    <span *ngIf="isSelected" class="menu-item-selected">
      <umss-icon name="phosphorCheck" [size]="iconSize"></umss-icon>
    </span>

  </button>
</div>
